import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { AxiosRequestConfig } from 'axios'
import { ClientItem } from '@/views/dashboard/_type/client-item'

export interface TerminalListReq {
   /** 分组id */
  group_id?: number
  /** 设备id */
  device_id?: string
  /** 顺序，true-正序，false-逆序 */
  asc?: boolean
  /** 设备id集合 */
  device_ids?: string[]
  /** 关键词搜索 */
  key_word?: string
  /** 每页数量 */
  limit?: number
  /** 终端状态 0-全部, 1-在线，2-离线 */
  login_status?: number
  /** 当前页 */
  page?: number
  /** 权益key集合 */
  permission_names?: string[]
  /** 获取设备状态 */
  require_terminal_status?: boolean
  /** 排序字段 */
  sort?: string
  /** 子网结束地址 */
  subnet_address_end?: string
  /** 子网开始地址 */
  subnet_address_start?: string
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type?: number
  /** 系统类型, 1-windows,2-linux, 3-server */
  system_types?: number[]
}

export interface TerminalListRes {
  total: number
  terminal_list: ClientItem[]
}
export interface terminalInfoRequestParams {
  /** 设备id */
  device_id: string
}

export interface Terminal {
  device_id: string
  group_id: number
  computer_name: string
  system_ip: string
  version: string
  defence_status: number
  user_mark: string
  mac: string
  system_name: string
  current_startup_time: number
  today_online_time: number
  last_startup_time: number
  last_offline_time: number
  login_status: number
  client_ip: string
  group_name: string
  system_type: number
  os: string
  hardware_info: string
}

export interface terminalInfoResponseData {
  terminal: Terminal
}
@Injectable()
export class SelectTerminalDrawerService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  getTerminalList (data: TerminalListReq, config: AxiosRequestConfig = {}) {
    return this.http.post<TerminalListRes>('/terminal/list', data, config)
  }
  getTerminalInfo (data: terminalInfoRequestParams) {
    return this.http.post<terminalInfoResponseData>('/terminal/info', data)
  }
}

